import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useNavigate  } from 'react-router-dom';
import { Button } from 'primereact/button';
import ShowError from '../shared/ShowError';
import Laoding from '../shared/Laoding';


export default function ShowIpgTransactionResult(props) {
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState("");
    const [verifying, setVerifying] = useState(true);
    const [transactionResult, setTransactionResult] = useState(null);

    useEffect(() => {
        setTransactionResult(props.result);
    }, []);
    
    return(
        <>
            {
                transactionResult == null?
                <></>
                :
            <Row className='justify-content-center align-items-center'>
                <Col className="d-flex justify-content-center align-items-center" md={3} style={{height:"calc(100vh - 70px)"}}>
                    <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", borderCollapse:"collapse", marginRight:"auto"}}>
                        <tbody>
                            <tr>
                                <td style={{width:"100%", textAlign:"center"}} colSpan={2}>
                                    <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                    {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1.1em", textAlign:"center", border:"1px solid #b0b0b0", padding:"5px"}}>{"تاریخ"}</td>
                                <td style={{fontSize:"1.1em", textAlign:"center", border:"1px solid #b0b0b0", padding:"5px"}}>{util.SeperateDate(transactionResult.transactionDate)}</td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1.1em", textAlign:"center", border:"1px solid #b0b0b0", padding:"5px"}}>{"زمان"}</td>
                                <td style={{fontSize:"1.1em", textAlign:"center", border:"1px solid #b0b0b0", padding:"5px"}}>{util.SeperateTime(transactionResult.transactionTime)}</td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1.1em", textAlign:"center", border:"1px solid #b0b0b0", padding:"5px"}}>{"مبلغ"}</td>
                                <td style={{fontSize:"1.1em", textAlign:"center", border:"1px solid #b0b0b0", padding:"5px"}}>{util.SeperatePrice(transactionResult.amount)}</td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"right", border:"1px solid #b0b0b0"}} colSpan={2}>
                                    {
                                        transactionResult.messages.map((ms, msInd)=>{
                                            return(
                                                <>
                                                    {ms}<br/>
                                                </>
                                            )
                                        })
                                    }
                                </td>
                            </tr>
                            {
                                transactionResult.continueLink == ""?
                                <></>
                                :
                                <>
                            <tr>
                                <td style={{fontSize:"1em", textAlign:"center", direction:"ltr"}} colSpan={2}>
                                    جهت تکمیل فرایند بر رو لینک زیر کلیک نمائید
                                    <br/>
                                    <a 
                                        href={transactionResult.continueLink} 
                                        style={{
                                        display: 'inline-block',
                                        padding: '10px 20px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        textDecoration: 'none',
                                        borderRadius: '5px'
                                        }}
                                    >
                                        تکمیل فرایند
                                    </a>
                                </td>
                            </tr>

                            <tr><td>&nbsp;</td></tr>
                                </>
                            }

                            <tr><td>&nbsp;</td></tr>

                        </tbody>
                    </table>
                </Col>
            </Row>
            }
        </>
    )
}